import { GradientButton } from "../GradientButton";
import { useAppDispatch } from "../../../hooks";
import { useCallback, useState } from "react";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { CustomToast } from "../CustomToast";
import {
  campaignsApi,
  useGeneratePlaybookForMembersMutation,
  useStartAccountPlanGenerationMutation,
} from "../../../api";
import { getErrorMessage } from "../../../utils/getErrorMessage";
import { setIsNotificationsOpen } from "../../../features/companySlice";

export const GetAccountPlanBtn = ({
  id,
  fullWidth,
  campaign_id,
  isPlaybook,
}: {
  id: string;
  campaign_id: string;
  fullWidth?: boolean;
  isPlaybook: boolean;
}) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [startGeneration, { isLoading: isGenerating }] =
    useStartAccountPlanGenerationMutation();

  const [generatePlaybookForMembers, { isLoading: isGeneratingPlaybooks }] =
    useGeneratePlaybookForMembersMutation();

  const handleStartGeneration = useCallback(async () => {
    setIsLoading(true);
    await (
      isPlaybook
        ? generatePlaybookForMembers({
            campaign_id,
            ids: [id],
            include_all: false,
          })
        : startGeneration({
            account_id: id,
            campaign_id,
          })
    )
      .unwrap()
      .catch((err) => {
        setIsLoading(false);
        toast.error(
          <CustomToast
            type="error"
            title="Failed to Start"
            text={
              getErrorMessage(err).globalError || "Failed to start generation"
            }
          />,
        );
      });

    dispatch(campaignsApi.util.invalidateTags(["activities"]));
    dispatch(setIsNotificationsOpen(true));
  }, [id, startGeneration, dispatch]);

  return (
    <GradientButton
      fullWidth={fullWidth}
      onClick={handleStartGeneration}
      disabled={isLoading || isGenerating || isGeneratingPlaybooks}
      sx={{
        whiteSpace: "nowrap",
        height: fullWidth ? "32px" : "42px",
      }}
      startIcon={
        (isLoading || isGenerating) && (
          <CircularProgress size={24} sx={{ color: "inherit" }} />
        )
      }
    >
      {isPlaybook ? "Generate Playbook" : "Get Target Account Plan"}
    </GradientButton>
  );
};
